import {useNavigation, useRoute} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {Keyboard, Platform, TouchableWithoutFeedback} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';

import {InputWithButton} from '../../../components/Interface/Forms/Inputs/InputWithButton';

import {Header} from '../../../components/Interface/Headers/Header';
import {Loading} from '../../../components/Interface/Loadings/Loading';
import {Toast} from '../../../components/Interface/Toast';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {StationItem} from '../../../components/shared/Stations/StationItem';

import {PedidoDTO} from '../../../dtos/PedidoDTO';
import {StationDTO} from '../../../dtos/StationDTO';

import {api} from '../../../services/api';

import {
  Container,
  Content,
  Footer,
  Form,
  InputContainer,
  InputGroup,
  StationsList,
  InputLabel,
  InputFooter,
  Plate,
  PlateRemove,
  InputFooterTitle,
  PlateRemoveText,
} from './styles';
import {PromoModal} from '../../../components/Interface/PromoModal';

import { SafeAreaView } from 'react-native-safe-area-context';
import { useAuth } from '../../../context/auth';

interface Params {
  pedidos: PedidoDTO;
  gnv?: boolean;
  returnTo?: string;

  discount?: {
    code: string;
    value: number;
    placa?: string;
    membro?: string;
    stations: StationDTO[];
  };
  localidade: {
    rank: string;
    tipo: string;
    region: string;
    estado: string;
    cidade: string;
  };
}

interface ListaPostoProps {
  placa?: string;
  codigo?: string;
}

export function Discount() {
  const route = useRoute();
  const {clientId} = useAuth();

  const navigation = useNavigation();

  const {pedidos, localidade, discount, returnTo} = route.params as Params;
  const isWebview = Platform.OS === 'web';

  const [isLoading, setIsLoading] = useState(false);
  const [inputIsLoading, setInputIsLoading] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);

  let placaJaInformada = discount?.placa
    ? discount.placa.length > 0
      ? true
      : false
    : false;

  let codigoMembroJaInformado = discount?.membro
    ? discount.membro.length > 0
      ? true
      : false
    : false;

  const [solicitaPlaca, setSolicitaPlaca] = useState(placaJaInformada);
  const [solicitaCodigoMembro, setSolicitaCodigoMembro] = useState(
    codigoMembroJaInformado,
  );

  const [placaInformada, setPlacaInformada] = useState(placaJaInformada);
  const [codigoMembroInformado, setCodigoMembroInformado] = useState(
    codigoMembroJaInformado,
  );

  const [placa, setPlaca] = useState<string | undefined>(
    discount?.placa ? discount.placa : '',
  );
  const [codigoMembro, setCodigoMembro] = useState<string | undefined>(
    discount?.membro ? discount.membro : '',
  );

  const [error, setError] = useState('');

  const [code, setCode] = useState(discount?.code ? discount.code : '');

  const [showDiscountAlertModal, setShowDiscountAlertModal] = useState(false);
  const [discountAlertModalMessage, setDiscountAlertModalMessage] =
    useState('');

  const [stations, setStations] = useState<StationDTO[]>(
    discount?.stations ? discount.stations : [],
  );

  useEffect(() => {
    if (discount?.code) {
      setShowCloseButton(true);
    }
  }, [discount?.code]);

  function handleInputCloseButton() {
    setShowCloseButton(false);
    setCode('');
    setPlaca('');
    setPlacaInformada(false);
    setCodigoMembroInformado(false);
    setSolicitaPlaca(false);
    setSolicitaCodigoMembro(false);
    setStations([]);
  }

  function handleTextChange(code: string) {
    setCode(code);
    setShowCloseButton(false);
    setPlaca('');
    setPlacaInformada(false);
    setCodigoMembroInformado(false);
    setSolicitaPlaca(false);
    setSolicitaCodigoMembro(false);
    setStations([]);
  }

  async function fetchExigePlaca() {
    setInputIsLoading(true);
    setShowDiscountAlertModal(false);
    await api
      .get('/solicitaPlaca?codigoDesconto=' + code)
      .then(response => {
        if (!response.data) {
          fetchDiscountStations({});
        } else {
          if (response.data === 'placa') {
            setSolicitaPlaca(true);
          }
          if (response.data === 'codigo') {
            setSolicitaCodigoMembro(true);
          }

          setShowCloseButton(true);
          setInputIsLoading(false);
        }
      })
      .catch(({response}) => {
        if (response.data.msg) {
          setError(response.data.msg);
        } else {
          setError('Código inválido');
        }

        setShowCloseButton(false);
        setInputIsLoading(false);
      });
  }

  async function fetchDiscountStations({placa, codigo}: ListaPostoProps) {
    await api
      .post('/listaPostosDesconto', {
        codigoDesconto: code.toLowerCase().replace(' ', ''),
        estado: localidade.region,
        placa: placa,
        codigo: codigo,
        clientId,
        isWebview,
        produtos: [
          {
            id: pedidos.fuelId,
            produto: pedidos.name,
            volume: pedidos.liters,
            quantity: pedidos.quantity,
          },
        ],
      })
      .then(({data}) => {
        if (placa) {
          setPlacaInformada(true);
        }

        if (codigo) {
          setCodigoMembroInformado(true);
        }

        setStations(data);
      })
      .catch(({response}) => {
        if (response.data.msg) {
          setError(response.data.msg);
        } else {
          setError('Código inválido');
        }

        setShowCloseButton(false);
      })
      .finally(() => {
        setInputIsLoading(false);
      });
  }

  function handleInputButton() {
    setShowCloseButton(true);
    Keyboard.dismiss();

    const codeDiscout = code.toLowerCase().replace(' ', '');

    if (codeDiscout === 'primeiravez') {
      setShowDiscountAlertModal(true);
      setDiscountAlertModalMessage(
        'Para usar o cupom "primeiravez", é essencial que o CPF associado à conta bancária para pagamento coincida com o CPF cadastrado na Baratão. Em casos de estorno, o valor será devolvido apenas para a conta bancária vinculada ao CPF de cadastro na Baratão.',
      );
    } else if (codeDiscout === 'clientevip') {
      setShowDiscountAlertModal(true);
      setDiscountAlertModalMessage(
        'Este cupom pode ser utilizado apenas três vezes por CPF.',
      );
    } else {
      fetchExigePlaca();
    }
  }

  async function handleAddDiscount() {
    setIsLoading(true);

    await api
      .post('/descontos', {
        codigoDesconto: code.toLowerCase().replace(' ', ''),
        produtos: [
          {
            id: pedidos.fuelId,
            produto: pedidos.name,
            volume: pedidos.liters,
            quantity: pedidos.quantity,
          },
        ],
        regiao: localidade.region,
      })
      .then(({data}) => {
        (navigation.navigate as any)({
          name: returnTo,
          params: {
            discount: {
              code,
              value: data,
              placa,
              membro: codigoMembro,
              stations,
            },
          },
          merge: true,
        });
      })
      .catch(({response}) => {
        if (response.data.error === 'Not discount found.') {
          if (response.data.msg) {
            setError(response.data.msg);
            setShowCloseButton(false);
          } else {
            setError('Código inválido');
            setShowCloseButton(false);
          }
        } else {
          setError('Ocorreu um erro');
          setShowCloseButton(false);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function handleChangePlacaText(extracted: any) {
    setPlaca(extracted);
  }

  function handleChangeCodigoMembroText(extracted: any) {
    setCodigoMembro(extracted);
  }

  function handleSetPlaca() {
    fetchDiscountStations({placa: placa});
  }

  function handleSetCodigoMembro() {
    fetchDiscountStations({codigo: codigoMembro});

  }

  function handleRemovePlaca() {
    setPlacaInformada(false);
    setPlaca('');
    setStations([]);
  }

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
    <TouchableWithoutFeedback onPress={() => Platform.OS !== 'web' && Keyboard.dismiss()}>
      <Container>
        {isLoading && <Loading />}
        <Header icon="chevron-left" />

        {error && (
          <Toast
            type="error"
            text={error}
            timeout={2000}
            onEnd={() => setError('')}
          />
        )}

        <Content>
          <Titles title="Cupom de desconto" />
          <Form>
            <InputWithButton
              buttonText="Aplicar"
              placeholder="Digite o código"
              enabled={code.length >= 3}

              loading={inputIsLoading}
              onChangeText={code => handleTextChange(code)}
              value={code}
              style={{
                marginRight: showCloseButton ? 0 : RFValue(12),
              }}
              autoCapitalize="none"
              onButtonPress={handleInputButton}
              onCloseButtonPress={handleInputCloseButton}
              showCloseButton={showCloseButton}
            />
          </Form>

          {placaInformada && (
            <InputFooter>
              <InputFooterTitle>
                Placa: <Plate>{placa}</Plate>
              </InputFooterTitle>
              <PlateRemove activeOpacity={1} onPress={handleRemovePlaca}>
                <PlateRemoveText>Remover</PlateRemoveText>
              </PlateRemove>
            </InputFooter>
          )}

          {codigoMembroInformado && (
            <InputFooter>
              <InputFooterTitle>
                Membro: <Plate>{codigoMembro}</Plate>
              </InputFooterTitle>
              <PlateRemove activeOpacity={1} onPress={handleRemovePlaca}>
                <PlateRemoveText>Remover</PlateRemoveText>
              </PlateRemove>
            </InputFooter>
          )}
          {!placaInformada && solicitaPlaca && (
            <InputContainer>
              <InputGroup>
                <InputLabel>Placa do veículo:</InputLabel>
                <InputWithButton
                  buttonText="Continuar"
                  placeholder="Digite a placa do veículo"
                  enabled={code.length >= 3}
                  loading={inputIsLoading}
                  onChangeText={(formatted, extracted) =>
                    handleChangePlacaText(extracted)
                  }
                  value={placa}
                  style={{
                    marginRight: showCloseButton ? 0 : RFValue(12),
                  }}
                  mask={'[AAA]-[0-99]'}
                  autoCapitalize="characters"
                  onButtonPress={handleSetPlaca}
                  onCloseButtonPress={handleInputCloseButton}
                />
              </InputGroup>
            </InputContainer>
          )}

          {!codigoMembroInformado && solicitaCodigoMembro && (
            <InputContainer>
              <InputGroup>
                <InputLabel>Código de membro:</InputLabel>
                <InputWithButton
                  buttonText="Continuar"
                  placeholder="Digite o código de membro"
                  enabled={code.length >= 3}
                  loading={inputIsLoading}
                  keyboardType="default"
                  onChangeText={text => handleChangeCodigoMembroText(text)}
                  value={codigoMembro}
                  style={{
                    marginRight: showCloseButton ? 0 : RFValue(12),
                  }}
                  autoCapitalize="characters"
                  onButtonPress={handleSetCodigoMembro}
                  onCloseButtonPress={handleInputCloseButton}
                />
              </InputGroup>
            </InputContainer>
          )}

          {stations.length !== 0 && (
            <StationsList
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{paddingBottom: RFValue(6)}}>
              {stations.map(item => (
                <StationItem data={item} key={item.id} disableAction />
              ))}
            </StationsList>
          )}
        </Content>

        <Footer>

            {stations.length !== 0 && (
              <Button
                enabled={code.length !== 0 && stations.length !== 0}
                title="Aplicar desconto"
                onPress={handleAddDiscount}
              />
            )}

          <PromoModal
            title="Antes de continuar..."
            text={discountAlertModalMessage}
            isVisible={showDiscountAlertModal}
            buttonAction={() => fetchExigePlaca()}
            buttonText="Ok, estou ciente!"
            headline="Aviso!"
            onDismiss={() => setShowDiscountAlertModal(false)}
          />
        </Footer>
      </Container>
    </TouchableWithoutFeedback>
    </SafeAreaView>
  );
}
